import React, { Fragment } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
const SharedUserList = ({users}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return(
    <Fragment>
      <Button endIcon={<ArrowDropDownIcon />} size="small" style={{marginLeft:'auto'}} variant="outlined" aria-controls="simple-menu" aria-haspopup="true" onClick={(event) => handleClick(event)}>
        Shared With
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {users.map((user) =>
          <MenuItem>{user.email}</MenuItem>
        )}
      </Menu>
    </Fragment>
  )
}
export default SharedUserList;
